import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import { useStores } from '@/hooks/use-stores';
import { useMeasurement } from '@/hooks/useMeasurement';
import { useValueByConnectivity } from '@/hooks/useValueByConnectivity';
import { AlertsWidget } from '@/comp/MapBuilder/components/AlertsWidget';
import { Ports } from '@/comp/MapBuilder/components/Ports';
import ConditionalToolTip from '@/utils/ConditionalTooltip';

import { DesiccantDryerConnectivityIcon } from '../DesiccantDryerConnectivityIcon';
import { useDewPointValue } from './DesiccantMapView.utils';
import { DesiccantMapViewContainer } from './DesiccantMapView.styles';
import PackageCareIndication from '../../nodeWidget/DetailsDrawer/PackageCareIndication/PackageCareIndication';

export const DesiccantMapView = observer(({ node, engine, height, width, borderInfo }) => {
  const { t } = useTranslation();
  const { tunit } = useMeasurement();
  const { tcunit, tcvalue } = useValueByConnectivity();
  const { stationStore } = useStores();

  const {
    connectivity,
    name,
    connectionType,
    dryerExtendedActivity,
    dewpointTemperatureCelsius,
    onDevices,
    modelDisplayName,
  } = node.getEntity();
  const deviceOnDevices = stationStore.currentStation?.devices?.filter(device => onDevices?.includes(device.deviceId));
  const dewPoint = useDewPointValue(dewpointTemperatureCelsius, deviceOnDevices);

  return (
    <DesiccantMapViewContainer $textColor={borderInfo?.textColor}>
      <div className="header">
        <ConditionalToolTip condition={true} content={name}>
          <div className="title-wrapper">
            <div className="ellipsis name">{name}</div>
            <div className="ellipsis type">{modelDisplayName}</div>
          </div>
        </ConditionalToolTip>
        <div>
          <DesiccantDryerConnectivityIcon
            connectivity={connectivity}
            connectionType={connectionType}
            dryerExtendedActivity={dryerExtendedActivity}
          />
        </div>
        {borderInfo && (
          <div className="in-maintenance-title">
            <span>{t(borderInfo.headerText)}</span>
          </div>
        )}
      </div>

      {dewPoint != null && (
        <div>
          <span className="value">{tcvalue(dewPoint, connectivity?.toLowerCase())}</span>
          <span className="label">{tcunit(tunit('°C'), dewPoint, connectivity)}</span>
        </div>
      )}
      <AlertsWidget alerts={node.alerts} />

      <Ports node={node} engine={engine} width={width} height={height} />
      <PackageCareIndication
        entity={node.getEntity()}
        mapView
        className="package-care-wrapper"
        backgroundColor={borderInfo?.fillColor}
      />
    </DesiccantMapViewContainer>
  );
});
